export default __webpack_public_path__ + "static/v1_3-5c1d740f3e4913f199e0272d644c82bf.webp";